import Link from 'next/link'
import { Image } from 'antd'
import { useState } from 'react'
import useTranslation from '@/hooks/useTranslation'

import PDFView from './modals/PDFView'
import Delete from '../svgs/formBuild/Delete'

const imageTypes = ['png', 'jpeg', 'jpg', 'tiff', 'svg']
const txtTypes = ['pdf']

const FileTabGreen = ({ fileLink, fileName, index, onDelete }) => {
  const { t } = useTranslation()

  const [pdfOpen, setPdfOpen] = useState(false)
  const [visible, setVisible] = useState(false)

  return (
    <>
      <div>
        <Link
          href={fileLink}
          target='_blank'
          rel='noreferrer'
          className={`flex items-center bg-green_100 text-green hover:text-green text-sm font-medium text-center border border-green rounded-md ${
            onDelete ? 'py-8' : 'py-6'
          } px-8 ltr:mr-4 rtl:ml-4`}
          onClick={(event) => {
            event.preventDefault()
            const fileType = fileLink.split('.').slice(-1)[0]

            if (txtTypes.includes(fileType)) {
              setPdfOpen(true)
            } else if (imageTypes.includes(fileType)) {
              setVisible(true)
            } else {
              window.open(fileLink, '_blank')
            }
          }}
        >
          {fileName || `${t('Document')} ${index + 1}`}
          {onDelete && (
            <Delete
              style={`ltr:ml-8 rtl:mr-8 w-16 cursor-pointer`}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                onDelete()
              }}
            />
          )}
        </Link>
      </div>
      <PDFView open={pdfOpen} setOpen={setPdfOpen} link={fileLink} />

      <Image
        className='image-link'
        width={0}
        style={{ display: 'none' }}
        src={fileLink}
        alt={fileLink}
        preview={{
          visible,
          onVisibleChange: (value) => {
            setVisible(value)
          },
        }}
      />
    </>
  )
}

export default FileTabGreen
